























































// @ is an alias to /src
import { Vue, Component, Prop } from "vue-property-decorator";
import ChatWindow from "@/libs/chat/ChatWindow";
import { namespace } from "vuex-class";
import User from "@/model/user";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import roomApi from "@/api/roomApi";
import messageApi from "@/api/messageApi";
import camelcaseKeys from "camelcase-keys";
import mqtt from "mqtt";
import fileApi from "@/api/fileApi";
import _ from "lodash";
import Company from "@/model/company";
import Contract from "@/model/contract";
import qNotify from "@/common/qNotify";
import trans18next from "@/i18n";
import $ from "jquery";

const authStore = namespace('Auth');

@Component({
  name: "MessageView",
  components: {
    ChatWindow,
  }
})
export default class MessageView extends Vue {
    @Prop({ default: "100vh" })
    public height;

    public rooms = [];
    public messages = [];
    public currentRoomId = null;
    public messagesLoaded = false;
    public loadingRooms = false;
    public roomsLoaded = true;
    public showAudio = false;
    public startMessages = null;
    public endMessages = null;
    public listeners = [];
    public client: any
    public currentUserId = "";
    public acceptedFiles = "image/png, image/jpg, image/jpeg";
    public page = 1;
    public isInit = false;
    public clientId: string;
    public unreadCount = 0;
    public cacheMessages = [];
    public firstRoomId = null;
    public companyId: string;
    public textMessages = {
      TYPE_MESSAGE: trans18next.t('messages.placeholder_input'),
      CONVERSATION_STARTED: trans18next.t('messages.conversation_date_on', { date: ''}),
    };
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    public noImage = require("@/assets/images/user-default-image.svg");
    public receiveUser = null;
    public showFooter = true;
    public isPreventEnter = true;
    public isMoveOut = false;
    public messageMoveOut = 'トーク相手がいません';
    public showTextArea = true;
    public showSendIcon = true;
    public showFiles = true;

    @authStore.Getter
    public getUserLogging!: User;

    @authStore.Getter
    public getCurrentyCompany!: Company;

    @authStore.Getter
    public getCurrentyContract!: Contract;

    @Prop({ default: false, type: Boolean })
    public singleRoom

    mounted() {
      this.companyId = _.get(this.getCurrentyCompany, 'id', _.get(this.getCurrentyContract, 'company_id'));
      this.resetMessages();
      this.currentUserId = this.getUserLogging.id;
      this.fetchMoreRooms();
      this.loadingRooms = true;
      this.connectSocket();
      // this.subscribeRoom(this.currentUserId);
      $('.mb__pagetop').addClass('none-display');
    }

    destroyed() {
      if (this.client.connected) {
        try {
          this.client.end()
          this.client = {
            connected: false,
          }
          console.log('Successfully disconnected!')
        } catch (error) {
          console.log('Disconnect failed', error.toString())
        }
      }
    }

    subscribeRoom(roomId) {
      this.client.subscribe(roomId, (error) => {
        console.log(error);
      });
    }

    private async connectSocket() {
      this.clientId = this.currentUserId + this.companyId + uuidv4();
      const options = {
        clientId: this.clientId,
        keepAlive: 60
      };

      try {
        this.client && this.client.end();
        const socketUrl = await messageApi.getSocketUrl();
        this.client = mqtt.connect(socketUrl, options);
        
      } catch (error) {
        console.log("mqtt.connect error", error);
      }

      this.client && this.client.on("connect", () => {
        this.client.subscribe(this.currentUserId, (error) => {
          console.log(error);
        });
        
      });

      this.client && this.client.on("message", (mqttTopic, message) => {
        const messages = message.toString().split(':');
        if (messages[1] == 'online' || messages[1] == 'offline') {
          // Update status on room.users.state
          this.rooms = _.map(this.rooms, (room) => {
            room.users = _.map(room.users, (user) => {
              if (user._id == messages[0]) {
                user.status = {
                  state: messages[1]
                };
              }

              return user;
            });

            return room;
          });

        } else {
          this.currentUserId === mqttTopic && this.addMessage(message.toString());
        }
      });

      this.client && this.client.on("reconnect", async () => {
        console.log(this.client);
        if (!this.client.connected) {
          setTimeout(async () => {
            await this.connectSocket();
          }, 5000);
        }
      });
    }

    private async fetchMoreRooms() {
      this.resetMessages();
      const dataRooms = await roomApi.list({
        company_id: this.companyId,
        contract_id: _.get(this.getCurrentyContract, 'id', '')
      });
      const rooms = camelcaseKeys(dataRooms, { deep: true, exclude: ['_id']});
      _.map(rooms, (room) => {
        this.rooms.push(room);
      });
      this.loadingRooms = false;
      if (this.isInit) {
        return;
      }

      if (!_.isEmpty(this.$route.query.roomId)) {
        this.firstRoomId = this.$route.query.roomId;
      } else {
        this.firstRoomId = !_.isEmpty(_.first(this.rooms)) ? _.first(this.rooms).roomId : null;
      } 
      this.isInit = true;
    }

    addMessage(message) {
      message = camelcaseKeys(JSON.parse(message), { exclude: ['_id'] });
      // use timeout to imitate async server fetched data
      if (this.currentRoomId != _.get(message, 'roomId')) {
        _.map(this.rooms, (room) => {
          if (_.get(message, 'roomId') == _.get(room, 'roomId')) {
            room.unreadCount++;
          }
          return room;
        });
      }

      _.map(this.rooms, (room) => {
        if (_.get(message, 'roomId') == _.get(room, 'roomId')) {
          setTimeout(() => {
            this.cacheMessages[_.get(room, 'roomId')].messages.push(message);
          });

          if (_.get(message, 'roomId') === this.currentRoomId) {
            setTimeout(() => {
              this.messages.push(message);
            });
          }
        }
      });
    }

    private async sendMessage({ content, roomId, file }) {
      const cDate = moment();
      const room = _.find(this.rooms, { roomId });
      if (file?.size > 10 * 1000 * 1000) {
        qNotify.error({
          text: this.$t('talk_room.file_upload_over_size_is_10')
        });
        return;
      }
      let message = {
        _id: uuidv4(),
        sender_id: this.currentUserId,
        content: !_.isEmpty(content) ? content : '',
        timestamp: cDate.format('YYYY-MM-DD HH:mm:ss'),
        username: _.get(this.getUserLogging, 'username', ''),
        avatar: _.get(this.getUserLogging, 'avatar.url', ''),
        date: cDate.format('MM月D日'),
        system: false,
        saved: true,
        distributed: true,
        seen: false,
        new: true,
        disable_actions: false,
        disable_reactions: false,
        room_id: roomId,
        file_id: null,
        file: null,
        receiver_id: null,
        index_id: Math.random(),
        property_id: _.get(room, 'propertyId', ''),
        contract_id: _.get(room, 'contractId', ''),
        user_type: _.get(room, 'userType', ''),
        receiver_user_company_id: _.get(room, 'receiverUserCompanyId', ''),
        __v: 0
      };
      if (file) {
        let formData = new FormData();
        formData.append("image", file.blob);
        formData.append("filemenu-actions_type", "Message");
        formData.append("notLoading", "true");

        const dataFile = await fileApi.uploadImage(formData);
        message.file_id = dataFile.data.id;

        // Handle upload file and set to message
        message.file = {
          name: file.name,
          size: file.size,
          type: file.type,
          extension: file.extension || file.type,
          url: dataFile.data.url,
        };
      }
      const userReceive = _.find(room.users, (user) => {
        return user._id != this.currentUserId;
      });
      message.receiver_id = _.get(userReceive, '_id');
      await messageApi.sendMessage(message);
      const camelMessage = camelcaseKeys(message, {exclude: ['_id']});
      this.messages.push(camelMessage);
      this.cacheMessages[this.currentRoomId].messages.push(camelMessage);
    }

    resetMessages() {
      this.page = 1;
      this.messages = [];
      this.messagesLoaded = false;
      this.setAllowSendMessage(true);
      this.textMessages.CONVERSATION_STARTED = trans18next.t('messages.conversation_date_on', { date: '' });
    }

    setAllowSendMessage(isAllow = true) {
      this.isMoveOut = !isAllow;
      this.showTextArea = isAllow;
      this.showSendIcon = isAllow;
      this.showFiles = isAllow;
    }

    async fetchMessages({ room, options }) {
      if (_.get(options, 'reset', false)) {
        this.resetMessages();
      }

      this.receiveUser = _.find(room.users, (user) => {
        return user._id != this.currentUserId
      });
      this.currentRoomId = room.roomId

      // When contract is moving out
      if (room.isMoveOut) {
        this.setAllowSendMessage(false);
      }

      if (!_.isEmpty(this.cacheMessages[this.currentRoomId]) && this.page == 1) {
        setTimeout(() => {
          _.map(this.cacheMessages[this.currentRoomId].messages, (item) => {
            this.messages.push(item);
          });
        });
      } else {

        const { list, paginate } = await messageApi.list({
          room_id: this.currentRoomId,
          page: this.page
        });

        // Read message unread
        await messageApi.readMessage({
          room_id: this.currentRoomId,
          notLoading: true
        });

        if (_.isEmpty(this.cacheMessages[this.currentRoomId])) {
          this.cacheMessages[this.currentRoomId] = {
            'messages': []
          };
        }

        this.cacheMessages[this.currentRoomId].pageCount = _.get(paginate, 'pageCount');

        const messages = camelcaseKeys(list, { exclude: ['_id'] });
        _.map(messages, (message) => {
          _.set(message, 'seen', true);
          _.set(message, 'saved', true);
          this.messages.unshift(message);
          if (this.page == 1) {
            this.cacheMessages[this.currentRoomId].messages.unshift(message);
          }
        });
      }

      if (this.page >= this.cacheMessages[this.currentRoomId].pageCount) {
        this.messagesLoaded = true;
      }
      if (this.messages.length > 0) {
        this.textMessages.CONVERSATION_STARTED = trans18next.t('messages.conversation_date_on', { date: room.conversationDateOn});
      }

      this.page++;

      // Update room with status have read all message
      _.map(this.rooms, (room) => {
        if (room.roomId == this.currentRoomId) {
          room.unreadCount = 0;
          return room;
        }
      });

    }

    get getAvatarCurrentUser() {
      return _.get(this.getUserLogging, 'avatar.url', this.noImage);
    }

    get getAvatarReceiveUser() {
      return !_.isEmpty(_.get(this.receiveUser, 'avatar')) ? _.get(this.receiveUser, 'avatar') : this.noImage
    }
}
